import {
  Tooltip as ChakraTooltip,
  TooltipProps,
  defineStyleConfig,
  forwardRef
} from '@chakra-ui/react';

export const Tooltip = forwardRef(function Tooltip(
  props: TooltipProps,
  ref
): JSX.Element {
  return <ChakraTooltip placement={'top'} ref={ref} {...props} />;
});

export const tooltipTheme = defineStyleConfig({
  baseStyle: {
    bg: 'palette_blue.5',
    p: 'space_unit.x2',
    borderRadius: 'radii.x2',
    color: 'palette_gray.100'
  }
});
